import React, { useCallback, useState } from "react";

import { Container, Row, Col } from "reactstrap";
import ImageViewer from "react-simple-image-viewer";

import Slider from "react-slick";

function News({ news }) {
  const settings = {
    dots: true,
    autoplay: true,
    arrows: false,
    autoplaySpeed: 8000,
    slidesToShow: 3,
    slidesToScroll: 1,
    className: "p-10",
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
        },
      },
      {
        breakpoint: 600,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
        },
      },
    ],
  };
  const [currentImage, setCurrentImage] = useState(0);
  const [isViewerOpen, setIsViewerOpen] = useState(false);
  const ims = images.map((n) => require(`assets/photos/${n}`));
  const openImageViewer = useCallback((index) => {
    setCurrentImage(index);
    setIsViewerOpen(true);
  }, []);

  const closeImageViewer = () => {
    setCurrentImage(0);
    setIsViewerOpen(false);
  };
  return (
    <>
      <div
        style={{
          backgroundColor: "#fff",
        }}
        className="section section-with-space"
        data-parallax={true}
      >
        <Container fluid>
          <Row className="justify-content-center">
            <Col lg={11} className={"ml-auto mr-auto mb-4"}>
              <Slider {...settings}>
                {images.map((n, index) => (
                  <img
                    src={require(`assets/photos/${n}`)}
                    width="100%"
                    alt="event"
                    className="px-1"
                    onClick={() => openImageViewer(index)}
                  />
                ))}
              </Slider>
            </Col>
          </Row>
          {isViewerOpen && (
            <ImageViewer
              src={ims}
              currentIndex={currentImage}
              disableScroll={false}
              closeOnClickOutside={true}
              onClose={closeImageViewer}
            />
          )}
        </Container>
      </div>
    </>
  );
}

export default News;

const images = [
  "_DSC6068.jpg",
  "_DSC6081.jpg",
  "_DSC6090.jpg",
  "_DSC6105.jpg",
  "_DSC6112.jpg",
  "_DSC6122.jpg",
  "_DSC6125.jpg",
  "_DSC6129.jpg",
  "_DSC6131.jpg",
  "_DSC6159.jpg",
  "_DSC6160.jpg",
  "_DSC6162.jpg",
  "_DSC6174.jpg",
  "_DSC6175.jpg",
  "_DSC6187.jpg",
  "_DSC6194.jpg",
  "A7407800.jpg",
  "A7407825.jpg",
  "A7407829.jpg",
  "A7407848.jpg",
  "A7407885.jpg",
];
